export enum InferenceServerType {
    ROBOFLOW = 'ROBOFLOW',
    MAKESENSE = 'MAKESENSE'
}